import {StoreType} from '..';
//types
import {INotifications} from '@/utils/types';

export const allNotificationSelector = (state: StoreType): INotifications => state.notificationStore.allNotificationData;
export const unreadNotificationSelector = (state: StoreType): INotifications => state.notificationStore.unreadNotificationData;


export const notificationLoaderSelector = (state: StoreType): boolean => state.notificationStore.isLoading;
